<div class="scanner-page" (click)="unlockAudio()">
  <header class="scanner-header">
    <div>
      <h1>Barcode Scanner</h1>
      <p>{{ modeLabels[mode] }}</p>
    </div>

    <div class="header-actions">
      <button mat-stroked-button color="primary" type="button" (click)="loadContext()">
        <mat-icon>sync</mat-icon>
        Refresh
      </button>
      <button mat-stroked-button type="button" (click)="unlockAudio()">
        <mat-icon>volume_up</mat-icon>
        Sound
      </button>
    </div>
  </header>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
  <div class="loading-label" *ngIf="loading">{{ loadingLabel }}</div>

  <section class="capture-band">
    <mat-form-field appearance="outline">
      <mat-label>Scanner Capture</mat-label>
      <input
        #scannerCapture
        matInput
        autocomplete="off"
        data-scanner-capture="true"
        (input)="scannerCapture.value = ''"
      />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Manual Barcode</mat-label>
      <input
        matInput
        name="manualBarcode"
        [(ngModel)]="manualBarcode"
        autocomplete="off"
        (keyup.enter)="submitManualBarcode()"
      />
    </mat-form-field>

    <button mat-flat-button color="primary" type="button" (click)="submitManualBarcode()">
      <mat-icon>keyboard_return</mat-icon>
      Submit
    </button>
  </section>

  <section class="scanner-grid">
    <div class="panel session-panel">
      <div class="panel-heading">
        <h2>Session</h2>
        <button mat-icon-button type="button" matTooltip="Start ASN lookup from scanned cartons" (click)="startAsnDetection()">
          <mat-icon>qr_code_scanner</mat-icon>
        </button>
      </div>

      <div class="session-form">
        <mat-form-field appearance="outline">
          <mat-label>Customer</mat-label>
          <mat-select name="poolPointClient" [(ngModel)]="selectedClientUuid" (selectionChange)="selectClient($event.value)">
            <mat-option value="">None</mat-option>
            <mat-option *ngFor="let client of poolClients" [value]="client.pool_point_client_uuid">
              {{ clientLabel(client) }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>ASN</mat-label>
          <input matInput name="asnEntry" [(ngModel)]="asnEntry" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Trailer</mat-label>
          <input matInput name="trailerEntry" [(ngModel)]="trailerEntry" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Store</mat-label>
          <mat-select name="selectedStore" [(ngModel)]="selectedStoreNumber" (selectionChange)="selectStore($event.value)">
            <mat-option value="">None</mat-option>
            <mat-option *ngFor="let store of storeOptions" [value]="store.store_number">
              {{ store.store_number }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="action-row">
        <button mat-flat-button color="primary" type="button" (click)="saveAsnAndTrailer()">
          <mat-icon>save</mat-icon>
          Save
        </button>
        <button mat-stroked-button type="button" (click)="fetchTripForAsn()">
          <mat-icon>travel_explore</mat-icon>
          Trip
        </button>
        <button mat-stroked-button type="button" (click)="generateBlindTrip()">
          <mat-icon>add_road</mat-icon>
          Blind
        </button>
        <button mat-stroked-button type="button" (click)="loadStores()">
          <mat-icon>storefront</mat-icon>
          Stores
        </button>
      </div>

      <div class="session-facts">
        <span>Trip <strong>{{ session.tripNumber || 'Open' }}</strong></span>
        <span>Trip List <strong>{{ session.tripListUuid || 'Open' }}</strong></span>
        <span>Serviced Stores <strong>{{ session.servicedStores.length }}</strong></span>
      </div>
    </div>

    <div class="panel workflow-panel">
      <h2>Workflow</h2>
      <div class="workflow-actions">
        <button mat-flat-button color="primary" type="button" (click)="startTripAudit(false)">
          <mat-icon>fact_check</mat-icon>
          Trip Audit
        </button>
        <button mat-flat-button color="primary" type="button" (click)="startTripAudit(true)">
          <mat-icon>visibility_off</mat-icon>
          Blind Audit
        </button>
        <button mat-flat-button color="accent" type="button" (click)="startStoreAudit()">
          <mat-icon>inventory_2</mat-icon>
          Store Audit
        </button>
        <button mat-stroked-button type="button" (click)="loadPallets()">
          <mat-icon>pallet</mat-icon>
          Pallets
        </button>
        <button mat-stroked-button type="button" (click)="loadBarcodeList()">
          <mat-icon>format_list_bulleted</mat-icon>
          Barcodes
        </button>
      </div>

      <div class="asn-detect" *ngIf="mode === 'asn-detect'">
        <span *ngFor="let barcode of asnDetectionBuffer">{{ barcode }}</span>
      </div>
    </div>
  </section>

  <section class="scanner-grid">
    <div class="panel list-panel">
      <div class="panel-heading">
        <h2>{{ modeLabels[mode] }} Items</h2>
        <span>{{ mode === 'pallet-products' ? packageProducts.length : products.length }}</span>
      </div>

      <div class="table-wrap" *ngIf="mode !== 'pallet-products'; else packageProductList">
        <table>
          <thead>
            <tr>
              <th>Barcode</th>
              <th>Store</th>
              <th>Status</th>
              <th>Return</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let product of products">
              <td>{{ product.barcode || recordString(product, 'barcode') }}</td>
              <td>{{ product.store_number || recordString(product, 'store_number') }}</td>
              <td>{{ productStatus(product) }}</td>
              <td>{{ product.return_status || recordString(product, 'return_status') }}</td>
              <td>
                <button mat-icon-button type="button" matTooltip="Report damage" (click)="setDamageBarcode(product.barcode || recordString(product, 'barcode'))">
                  <mat-icon>report_problem</mat-icon>
                </button>
              </td>
            </tr>
            <tr *ngIf="products.length === 0">
              <td colspan="5">No items loaded.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <ng-template #packageProductList>
        <div class="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Barcode</th>
                <th>Store</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let product of packageProducts">
                <td>{{ product.barcode || recordString(product, 'barcode') }}</td>
                <td>{{ product.store_number || recordString(product, 'store_number') }}</td>
                <td>{{ productStatus(product) }}</td>
                <td>
                  <button mat-icon-button type="button" matTooltip="Remove from pallet" (click)="removeProductFromPallet(product)">
                    <mat-icon>remove_circle_outline</mat-icon>
                  </button>
                </td>
              </tr>
              <tr *ngIf="packageProducts.length === 0">
                <td colspan="4">No cartons loaded.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-template>
    </div>

    <div class="panel side-panel">
      <h2>Pallets</h2>
      <div class="pallet-list">
        <button
          mat-stroked-button
          type="button"
          *ngFor="let pallet of pallets"
          [class.selected]="selectedPallet === pallet"
          (click)="loadPackageProducts(pallet)"
        >
          <mat-icon>inventory</mat-icon>
          {{ recordString(pallet, 'store_number') || session.storeNumber || 'Store' }}
          <span>{{ recordString(pallet, 'carton_count') || '0' }}</span>
        </button>
      </div>

      <div class="pallet-form">
        <mat-form-field appearance="outline">
          <mat-label>Height</mat-label>
          <input matInput type="number" name="palletHeight" [(ngModel)]="palletForm.height" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Length</mat-label>
          <input matInput type="number" name="palletLength" [(ngModel)]="palletForm.length" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Width</mat-label>
          <input matInput type="number" name="palletWidth" [(ngModel)]="palletForm.width" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Weight</mat-label>
          <input matInput type="number" name="palletWeight" [(ngModel)]="palletForm.weight" />
        </mat-form-field>
      </div>

      <button mat-flat-button color="accent" type="button" (click)="createPallet()">
        <mat-icon>add_box</mat-icon>
        Create Pallet
      </button>
    </div>
  </section>

  <section class="scanner-grid">
    <div class="panel damage-panel">
      <h2>Damage</h2>
      <mat-form-field appearance="outline">
        <mat-label>Barcode</mat-label>
        <input matInput name="damageBarcode" [(ngModel)]="damageBarcode" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Resolution</mat-label>
        <mat-select name="damageResolution" [(ngModel)]="damageResolution">
          <mat-option *ngFor="let resolution of damageResolutions" [value]="resolution">
            {{ resolution }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <button mat-flat-button color="warn" type="button" (click)="submitDamage()">
        <mat-icon>assignment_late</mat-icon>
        Submit
      </button>
    </div>

    <div class="panel diagnostics-panel">
      <h2>Scanner Sources</h2>
      <div class="adapter-row" *ngFor="let status of statuses">
        <mat-icon [class.active]="status.active">{{ status.available ? 'sensors' : 'sensors_off' }}</mat-icon>
        <div>
          <strong>{{ status.label }}</strong>
          <span>{{ status.detail }}</span>
        </div>
        <button *ngIf="status.source === 'webhid'" mat-icon-button type="button" matTooltip="Probe WebHID" (click)="probeAdapter('webhid')">
          <mat-icon>search</mat-icon>
        </button>
        <button *ngIf="status.source === 'webusb'" mat-icon-button type="button" matTooltip="Probe WebUSB" (click)="probeAdapter('webusb')">
          <mat-icon>search</mat-icon>
        </button>
        <button *ngIf="status.source === 'webserial'" mat-icon-button type="button" matTooltip="Probe WebSerial" (click)="probeAdapter('webserial')">
          <mat-icon>search</mat-icon>
        </button>
      </div>
    </div>
  </section>

  <section class="panel log-panel">
    <div class="panel-heading">
      <h2>Recent Scans</h2>
      <span>{{ scanLog.length }}</span>
    </div>
    <div class="log-list">
      <div class="log-row" *ngFor="let log of scanLog" [class]="log.outcome">
        <span>{{ log.timestamp | date:'shortTime' }}</span>
        <strong>{{ log.barcode }}</strong>
        <em>{{ modeLabels[log.mode] }} / {{ log.source }}</em>
        <p>{{ log.message }}</p>
      </div>
    </div>
  </section>
</div>
